import { reducer } from "./reducer";
// import { createStore } from 'redux';

// export const store = createStore(reducer);


import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
 
 
const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, reducer)
 
let store = createStore(persistedReducer)
let persistor = persistStore(store)
export { store, persistor }
